module.exports = function(app) {
	"use strict";
  app
  .directive('searchRatingDir',searchRatingDir);
	searchRatingDir.$inject = ['keyPress','$timeout','serverError','alertService','refreshtokenService','offlineError','postDataService','getDataService','$rootScope'];
    function searchRatingDir(keyPress,$timeout,serverError,alertService,refreshtokenService,offlineError,postDataService,getDataService,$rootScope) {
    return {
      restrict: 'E',
      scope: {
          parentObj:"=",
          editor:'=',
          postId:'=',
          ratingResultDisplay:'='
      },
      replace:true,
      template: require('./partial/searchRating.html'),
      link: function(scope, element, attrs, ngModel) {
        scope.requiredPoll = false;
        scope.ratingResult = false;
        scope.insertRating = function() {
          function addRatingFunc() {
              var insertRatingToEditorObj = {
                _id: scope.searchObj._id,
              }
              if(scope.ratingResultDisplay) {
                insertRatingToEditorObj.result = scope.ratingResult
              }
              scope.$parent.$parent.$broadcast('insert-rating-to-editor', insertRatingToEditorObj);
            searchRatingReset()
            // scope.selectedPollAction.value = 'default';
            $timeout(function () {
              scope.parentObj.cancelRatingModal()
            }, 0)
          }
          if(scope.searchObj && scope.searchRatingData) {
            scope.requiredRating = false;
            if(scope.postId) {
              var postFunction = function() {
                postDataService.save({
                  param1:'ratings',
                  param2:'attachToPost'
                },{
                  'post_id':scope.postId,
                  'rating_id':scope.searchObj._id,
                }).$promise.then(function(data){
                  addRatingFunc()
                  scope.ratingModalShow = false;
                  $rootScope.modalShow = false;
                }, function(error){
                  if(!window.navigator.onLine) {
                    offlineError()
                    alertService('danger','Opps! ', 'Please check your internet connection and try again.');
                    return
                  }
                  if(error.status ==401) {
                    var promise = refreshtokenService.getAccessToken();
                    promise.then(
                      function(answer) {
                        if(answer==200) {
                          postFunction();
                        }
                      },
                      function(error) {
                      },
                      function(progress) {
                        // report progress
                    });
                  } else if(error.status ==502) {
                    serverError()
                  } else {
                    alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
                  }  
                });
              }
              postFunction();
            } else {
              addRatingFunc()
            }
          } else {
            alertService('danger','Opps! ', 'Choose rating');
            scope.requiredRating = true;
          }  
        }
        scope.hiddenResult = true;
        scope.hasResult = true;
        scope.ratingArray = [];
        scope.searchPage = 0;
        scope.chooseSearchData = function(rating) {
          scope.searchRatingData = '('+rating._id+') - ' +  rating.title;
          scope.hiddenResult = true;
          scope.searchObj = {
            '_id': rating._id,
            'title' : rating.title,
          };
        };
        function mouseDown(e) {
          if(angular.element(document.getElementsByClassName("autocomplete-result"))) {
          var container = angular.element(document.getElementsByClassName("autocomplete-result"));
          var serch_input = angular.element(document.getElementsByClassName("search-autocomplete"));
          if (!container.is(e.target) // if the target of the click isn't the container...
            && container.has(e.target).length === 0 && !scope.hiddenResult && !serch_input.is(e.target) && serch_input.has(e.target).length===0) // ... nor a descendant of the container
          {
            scope.$apply(function () {
              scope.hiddenResult = true;
              scope.ratingArray = [];
              scope.searchPage = 1;
            });
          }}
        }
        angular.element(document).on('mousedown',mouseDown);
        scope.searchPress = function(evt,star) {
          keyPress(evt,star);
        }
        scope.readMore = function() {
          scope.searchPage ++;
          $timeout(function() {
            scope.search('loadMore');
          },0)
        }
        var getPollsFunction = function(loadMore) {
        //   var excludeby;
          var status = 'publish,finish';
        //   if(scope.parentObj.addPollToRecomended) {
        //     excludeby = 'content';
        //     status = 'publish'
        //   }
          getDataService.get({
            param1:'ratings', 
            status:status,
            s: scope.searchRatingData,
            limit:20,
            page: scope.searchPage,
            // excludeby:excludeby
          }).$promise.then(function(data){
            // $element.after($compile(modal)($scope));
            if(loadMore=='loadMore') {
              scope.ratingArray = scope.ratingArray.concat(data.ratings);
            } else {
              scope.ratingArray = data.ratings;
            }
            if(scope.ratingArray.length > 0) {
              scope.hasResult = true;
              scope.loadMore = true;
            } else {
              scope.hasResult = false;
            }
            scope.hiddenResult = false;
            if(data.count >scope.ratingArray.length) {
              scope.loadMore = true;
            } else {
              scope.loadMore = false;
            }
          }, function(error){
            if(!window.navigator.onLine) {
              offlineError()
              return
            }
            if(error.status ==401) {
              var promise = refreshtokenService.getAccessToken();
              promise.then(
                function(answer) {
                  if(answer==200) {
                    getPollsFunction(loadMore);
                  }
                },
                function(error) {
                },
                function(progress) {
                  // report progress
              });
            } else if(error.status ==502) {
              serverError()
            } else {
              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
            }  
          });
        }
        function searchRatingReset() {
          scope.searchRatingData = null;
          scope.searchObj = null;
        }
        scope.search = function(loadMore,initialLoad) { 
          scope.loadMore = false;
          if(loadMore!='loadMore') {
            scope.searchPage = 1;
            scope.ratingArray = [];
          }
          if(initialLoad || loadMore) {
            getPollsFunction(loadMore);
          } else {
            if(scope.searchRatingData) { 
              if(scope.searchRatingData.length >0) {
                getPollsFunction(loadMore);
              } else {
                scope.hiddenResult = true;
              } 
            } else {
              scope.hiddenResult = true;
              searchRatingReset()
            }
          }
        }
        scope.search(null,true)
        scope.$on('$destroy',function(){
          angular.element(document).off('mousedown',mouseDown);
        })
      }
    }
  }	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/directive/searchRating/searchRatingDirective.js
// module id = 450
// module chunks = 0